<app-loading-spinner
  *ngIf="isLoading"
  class="spinner-full-page"
/>

<mat-card
  *ngIf="!isLoading"
  class="full-content"
>
  <mat-card-title class="content-header">{{ customerName }} </mat-card-title>

  <mat-card-content class="content">
    <div
      id="back-button"
      style="margin-left: 20px; margin-right: 20px; display: flex; justify-content: flex-end"
    >
      <button
        class="back-button"
        mat-button
        (click)="back()"
      >
        <span
          matTooltip="Logout"
          class="material-icons"
        >
          close
        </span>
      </button>
    </div>

    <mat-card
      id="enquiry-details"
      class="section-card"
    >
      <mat-card-title class="section-header">Enquiry Details</mat-card-title>

      <mat-card-content class="no-padding">
        <div class="grid-display-2">
          <p>Enquiry Number:</p>
          <b>{{ enquiryBasicData.enquiryNum }}</b>

          <p>Enquiry Date:</p>
          <b>{{ enquiryBasicData.enquiryDate }}</b>

          <p>Relationship Manager:</p>
          <b>{{ relationshipManagerData.name }}</b>

          <p>Delivery Address:</p>
          <b>{{ enquiryBasicData.deliveryAddress }}</b>

          <p>Delivery PIN Code:</p>
          <b>{{ enquiryBasicData.deliveryPincode | pincodeNumberFormat }}</b>

          <app-report-issue-button
            [entityId]="customerOrderId"
            [entityType]="entityType"
            [isInternalUser]="false"
            [contactNumberWhatsapp]="relationshipManagerData.mobile"
          />

          <app-share-requirements-button [publicId]="publicRequirementsId"> </app-share-requirements-button>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- <mat-card
      id="requirement-items"
      class="section-card normal-text"
    >
      <mat-card-title class="section-header">Requirement Items</mat-card-title>

      <div class="scroll-x-container">
        <table
          mat-table
          [dataSource]="orderItemDataSource"
        >
          <ng-container
            matColumnDef="category"
            [sticky]="true"
          >
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Category </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.category }}
            </td>
          </ng-container>

          <ng-container matColumnDef="product">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Product </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.product }}
            </td>
          </ng-container>

          <ng-container matColumnDef="make">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Make </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.make }}
            </td>
          </ng-container>

          <ng-container matColumnDef="grade">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Grade </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.grade }}
            </td>
          </ng-container>

          <ng-container matColumnDef="brand">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Brand </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.brand }}
            </td>
          </ng-container>

          <ng-container matColumnDef="type">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Type </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.type }}
            </td>
          </ng-container>

          <ng-container matColumnDef="property">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Property </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.property }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dimension">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Dimension </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.dimension }}
            </td>
          </ng-container>

          <ng-container matColumnDef="customDimensions">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Custom Dimensions </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.customDimensions }}
            </td>
          </ng-container>

          <ng-container matColumnDef="qty">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Quantity </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.qty }}
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="requirementItemColumns"
          ></tr>

          <tr
            mat-row
            *matRowDef="let row; columns: requirementItemColumns"
            class="mat-row"
          ></tr>
        </table>
      </div>
    </mat-card> -->

    <mat-card
      id="quotes"
      class="section-card"
    >
      <mat-card-title class="section-header">Quotes </mat-card-title>

      <div class="grid-display-2">
        <ng-container *ngFor="let row of quotationList; let i = index">
          <p>{{ row.quotationNum }}</p>

          <app-file-download-button
            style="margin-left: auto"
            [fileUrl]="row.quotationPdfUrl"
          />

          <ul style="grid-column: span 2">
            <li>{{ row.quotationMessage }}</li>
          </ul>

          <hr style="grid-column: span 2" />
        </ng-container>
      </div>
    </mat-card>

    <mat-card
      id="invoices"
      class="section-card"
    >
      <mat-card-title class="section-header">Invoices</mat-card-title>

      <app-loading-spinner *ngIf="invoicesDataLoader" />

      <div class="grid-display-3">
        <ng-container *ngFor="let row of invoiceList; let i = index">
          <p>{{ row.invoiceNum }}</p>

          <p style="text-align: center">&#8377; {{ row.totalInvoiceAmount }}</p>

          <div class="chips">
            <mat-chip
              class="status-chip"
              [ngClass]="getInvoiceStatusChipClass(row.invoiceDeliveryStatus)"
            >
              {{ row.invoiceDeliveryStatus.value }}
            </mat-chip>
          </div>

          <button
            mat-button
            class="file-download-button"
            [disabled]="!row.customerInvoiceFileUrl"
            (click)="onFileDownloadNoAuth(row.customerInvoiceFileUrl)"
            title="Invoice File file download"
          >
            Invoice File
          </button>

          <button
            mat-button
            class="file-download-button"
            [disabled]="!row.materialTestCertificateFileUrl"
            (click)="onFileDownloadAuth(row.materialTestCertificateFileUrl)"
            title="Material Test Certificate file download"
          >
            Material Test Certificate
          </button>

          <button
            mat-button
            class="file-download-button"
            [disabled]="!row.customerInvoiceFileUrl"
            (click)="onFileDownloadNoAuth(row.customerInvoiceFileUrl)"
            title="Invoice File file download"
          >
            GRN File
          </button>

          <hr style="grid-column: span 3" />
        </ng-container>
      </div>
      <mat-paginator
        #invoicePaginator
        [hidePageSize]="true"
        [pageSize]="invoicesPageSize"
        (page)="onChangePage($event)"
        [length]="invoicesDataLength"
      />
    </mat-card>

    <mat-card
      id="relationship-manager"
      class="section-card"
    >
      <div class="rm">
        <mat-card-title class="section-header">Relationship Manager</mat-card-title>
        <div class="grid-display-3">
          <b style="grid-column: span 3">
            {{ relationshipManagerData.name }}
          </b>

          <p>Email:</p>
          <p style="grid-column: span 2">{{ relationshipManagerData.email }}</p>

          <p>Mobile:</p>
          <p style="grid-column: span 2">{{ relationshipManagerData.mobile | mobileNumberFormat }}</p>
        </div>
      </div>

      <div
        class="rm"
        *ngIf="relationshipManagerSeniorData"
      >
        <hr style="grid-column: span 3" />

        <mat-card-title class="section-header">Escalation Manager </mat-card-title>

        <div class="grid-display-3">
          <b style="grid-column: span 3">
            {{ relationshipManagerSeniorData.name }}
          </b>

          <p>Email:</p>
          <p style="grid-column: span 2">{{ relationshipManagerSeniorData.email }}</p>

          <p>Mobile:</p>
          <p style="grid-column: span 2">{{ relationshipManagerSeniorData.mobile | mobileNumberFormat }}</p>
        </div>
      </div>
    </mat-card>
  </mat-card-content>
</mat-card>
